import React, { useEffect, useState } from "react";
import { Row, Col, Tabs, Tab, Accordion } from "react-bootstrap";
import styles from "./patientProfile.module.scss";
import { useNavigate } from "react-router-dom";
import { FaArrowLeft } from "react-icons/fa";
import { useDispatch, useSelector } from "react-redux";
import {
  getPatientIdSlice,
  resetCurrentPatientProfile
} from "../../../store/slices/patientSlice";
import patientMaleImage from "../../../images/CCImages/PatientImageMale.png";
import patientFemaleImage from "../../../images/CCImages/PatientImageFeMale.png";
import ViewModal from "../Patient/ViewModal";
import PrescriptionSection from "./Sections/PrescriptionSection";
import VitalReportSection from "./Sections/VitalReportSection";
import DiagnosticReportSection from "./Sections/DiagnosticReportSection";
import DischargeSummarySection from "./Sections/DischargeSummarySection";
import HealthDocumentSection from "./Sections/HealthDocumentSection";
import ImmunizationRecordSection from "./Sections/ImmunizationRecordSection";
import OPConsultSection from "./Sections/OPConsultSection";
import InvoiceRecordSection from "./Sections/InvoiceRecordSection";
// import PathologyLabReportSection from "./Sections/PathologyLabReportSection";
import InPatientSection from "./Sections/InPatientSection";
import AbhaM3Section from "./Sections/AbhaM3Section";
import { resetPatientLabReportsState } from "../../../store/slices/labReportSlice";
import { resetPatientRadiologyReportsState } from "../../../store/slices/radiologyReport";
import { resetPatientInvoiceDetailsState } from "../../../store/slices/invoiceSlice";
const PatientProfile = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const patientId = sessionStorage.getItem("id");
  const { token } = useSelector((state) => state.auth);
  const { patientData } = useSelector((state) => state.patient);
  const [viewModal, setViewModal] = useState(false);

  useEffect(() => {
    if (patientId && token) {
      dispatch(resetCurrentPatientProfile());
      dispatch(resetPatientLabReportsState());
      dispatch(resetPatientRadiologyReportsState());
      dispatch(resetPatientInvoiceDetailsState());
      dispatch(getPatientIdSlice({ patientId, token }));
    }
  }, [patientId, token, dispatch]);

  const goBack = () => {
    navigate("/patient");
  };

  const handleShowGlobalViewModal = () => {
    setViewModal(true);
  };

  return (
    <div className={styles.container}>
      <Row className={styles.rowFull}>
        <Col md={4} className={`p-0 ${styles.leftPanel}`}>
          <div>
            <div className={styles.infoHeading}>
              <button className="btn btn-sm btn-primary" onClick={goBack}>
                <FaArrowLeft /> Go Back
              </button>
              <h3 className="mb-0">Patient Info</h3>
            </div>
            <div className="info">
              <div className={`${styles.infoProfile} text-center p-3`}>
                <img
                  src={
                    patientData?.patient_image
                      ? patientData?.patient_image
                      : patientData?.gender === "Female"
                        ? patientFemaleImage
                        : patientMaleImage
                  }
                  alt="PatientImage"
                  className={`rounded-circle border ${styles.patientImage}`}
                />
                <h4 className={styles.patientName}>
                  {patientData?.gender === "Male" ? "MR." : "MS."}{" "}
                  {patientData?.name}
                </h4>
              </div>
              <div className={styles.infoBody}>
                <ul className={styles.infoList}>
                  <li className={styles.infoItem}>
                    <strong className="text-dark">UHID:</strong>
                    <span className="text-muted">
                      {patientData?.UHID || "N/A"}
                    </span>
                  </li>
                  <li className={styles.infoItem}>
                    <strong className="text-dark">Age:</strong>
                    <span className="text-muted">
                      {patientData?.age?.year || "N/A"}
                    </span>
                  </li>
                  <li className={styles.infoItem}>
                    <strong className="text-dark">Date of Birth:</strong>
                    <span className="text-muted">
                      {patientData?.dob?.split("T")[0] || "N/A"}
                    </span>
                  </li>
                  <li className={styles.infoItem}>
                    <strong className="text-dark">Gender:</strong>
                    <span className="text-muted">
                      {patientData?.gender || "N/A"}
                    </span>
                  </li>
                  <li className={styles.infoItem}>
                    <strong className="text-dark">Address:</strong>
                    <span className={styles.addressWrapper}>
                      <span className={styles.addressShort}>
                        {patientData?.address
                          ?.split(" ")
                          .slice(0, 2)
                          .join(" ") + "..."}
                      </span>
                      <span className={styles.addressTooltip}>
                        {patientData?.address}
                      </span>
                    </span>
                  </li>
                  <li className={styles.infoItem}>
                    <strong className="text-dark">Email:</strong>
                    <span className="text-muted text-end">
                      {patientData?.email || "N/A"}
                    </span>
                  </li>
                  <li className={styles.infoItem}>
                    <strong className="text-dark">Mobile:</strong>
                    <span className="text-muted">
                      +91 {patientData?.phone || "N/A"}
                    </span>
                  </li>
                </ul>
                <button
                  className="btn btn-primary btn-sm w-100 shadow-sm"
                  onClick={handleShowGlobalViewModal}
                >
                  View Full Details
                </button>
              </div>
            </div>
          </div>
        </Col>

        <Col md={8} className={styles.rightPanel}>
          <Tabs
            defaultActiveKey="Intake"
            id="patient-tabs"
            className={`mb-0 nav-tabs ${styles.tabsHeader}`}
            mountOnEnter
            unmountOnExit
          >
            <Tab eventKey="Intake" title="Intake">
              <div className={styles.tabContent}>
                <Accordion>
                  <Accordion.Item eventKey="0" className={styles.accordionItem}>
                    <Accordion.Header className={styles.accordionHeader}>
                      In Patient
                    </Accordion.Header>
                    <Accordion.Body className={styles.accordionBody}>
                      <InPatientSection
                        patientId={patientId}
                        patientData={patientData}
                      />
                    </Accordion.Body>
                  </Accordion.Item>

                  <Accordion.Item eventKey="1">
                    <Accordion.Header>Create Appointment</Accordion.Header>
                    <Accordion.Body>
                      Content for Create Appointment
                    </Accordion.Body>
                  </Accordion.Item>

                  <Accordion.Item eventKey="2">
                    <Accordion.Header>Pharmacy</Accordion.Header>
                    <Accordion.Body>Content for Pharmacy</Accordion.Body>
                  </Accordion.Item>

                  <Accordion.Item eventKey="3">
                    <Accordion.Header>Other Services</Accordion.Header>
                    <Accordion.Body>Content for Other Services</Accordion.Body>
                  </Accordion.Item>

                  <Accordion.Item eventKey="4">
                    <Accordion.Header>Estimation</Accordion.Header>
                    <Accordion.Body>Content for Estimation</Accordion.Body>
                  </Accordion.Item>
                </Accordion>
              </div>
            </Tab>
            <Tab eventKey="Screening" title="Screening">
              <div className={styles.tabContent}>
                <Accordion>
                  <Accordion.Item eventKey="0" className={styles.accordionItem}>
                    <Accordion.Header className={styles.accordionHeader}>
                      Vitals Report
                    </Accordion.Header>
                    <Accordion.Body className={styles.accordionBody}>
                      <VitalReportSection
                        patientId={patientId}
                        patientData={patientData}
                      />
                    </Accordion.Body>
                  </Accordion.Item>
                  <Accordion.Item eventKey="1">
                    <Accordion.Header>Prescription</Accordion.Header>
                    <Accordion.Body>
                      <PrescriptionSection
                        patientId={patientId}
                        patientData={patientData}
                      />
                    </Accordion.Body>
                  </Accordion.Item>
                  {/* <Accordion.Item eventKey="2">
                    <Accordion.Header>Pathology Lab Report</Accordion.Header>
                    <Accordion.Body>
                      <PathologyLabReportSection patientId={patientId} />
                    </Accordion.Body>
                  </Accordion.Item> */}
                  {/* <Accordion.Item eventKey="3">
                    <Accordion.Header>
                      Health Screening Lab Report
                    </Accordion.Header>
                    <Accordion.Body>
                      Content for Health Screening Lab Report
                    </Accordion.Body>
                  </Accordion.Item>
                  <Accordion.Item eventKey="4">
                    <Accordion.Header>
                      Health Package Lab Report
                    </Accordion.Header>
                    <Accordion.Body>
                      Content for Health Package Lab Report
                    </Accordion.Body>
                  </Accordion.Item> */}
                  <Accordion.Item eventKey="5">
                    <Accordion.Header>Diagnostic Report</Accordion.Header>
                    <Accordion.Body>
                      <DiagnosticReportSection
                        patientId={patientId}
                        patientData={patientData}
                      />
                    </Accordion.Body>
                  </Accordion.Item>
                  <Accordion.Item eventKey="6">
                    <Accordion.Header>OP Consult</Accordion.Header>
                    <Accordion.Body>
                      <OPConsultSection
                        patientId={patientId}
                        patientData={patientData}
                      />
                    </Accordion.Body>
                  </Accordion.Item>
                  <Accordion.Item eventKey="7">
                    <Accordion.Header>Immunization Record</Accordion.Header>
                    <Accordion.Body>
                      <ImmunizationRecordSection
                        patientId={patientId}
                        patientData={patientData}
                      />
                    </Accordion.Body>
                  </Accordion.Item>
                  <Accordion.Item eventKey="8">
                    <Accordion.Header>Health Document</Accordion.Header>
                    <Accordion.Body>
                      <HealthDocumentSection
                        patientId={patientId}
                        patientData={patientData}
                      />
                    </Accordion.Body>
                  </Accordion.Item>
                   <Accordion.Item eventKey="9">
                                      <Accordion.Header>ABDM Milestone 3 (HIU)</Accordion.Header>
                                      <Accordion.Body>
                                        <AbhaM3Section patientData={patientData} />
                                      </Accordion.Body>
                                    </Accordion.Item>
                </Accordion>
              </div>
            </Tab>
            <Tab eventKey="CarePlan" title="Care Plan">
              <div className={styles.tabContent}>
                <p>Care Plan tab content</p>
              </div>
            </Tab>
            <Tab eventKey="CaseClosure" title="Case Closure">
              <div className={styles.tabContent}>
                <Accordion>
                  <Accordion.Item eventKey="0">
                    <Accordion.Header>Invoice Record</Accordion.Header>
                    <Accordion.Body>
                      <InvoiceRecordSection
                        patientId={patientId}
                        patientData={patientData}
                      />
                    </Accordion.Body>
                  </Accordion.Item>

                  {/* <Accordion.Item eventKey="1">
                    <Accordion.Header>Pharmacy Sales</Accordion.Header>
                    <Accordion.Body>Content for Pharmacy Sales</Accordion.Body>
                  </Accordion.Item> */}

                  <Accordion.Item eventKey="2">
                    <Accordion.Header>Discharge Summary</Accordion.Header>
                    <Accordion.Body>
                      <DischargeSummarySection
                        patientId={patientId}
                        patientData={patientData}
                      />
                    </Accordion.Body>
                  </Accordion.Item>
                </Accordion>
              </div>
            </Tab>
          </Tabs>
        </Col>
      </Row>

      <ViewModal
        viewModal={viewModal}
        setViewModal={setViewModal}
        patientData={patientData}
      />
    </div>
  );
};

export default PatientProfile;
